<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="40" height="40" rx="8" fill="#F7F8F8" fill-opacity="0.12"/>
<circle cx="19.792" cy="14" r="6.5" fill="url(#paint0_linear_8738_113276)"/>
<rect x="12.1941" y="12.3887" width="8.778" height="1.09725" rx="0.548625" fill="#2D2C61"/>
<rect x="23.167" y="12.3887" width="4.389" height="1.09725" rx="0.548625" fill="#2D2C61"/>
<path d="M10 29.0835C10 25.4475 12.9475 22.5 16.5835 22.5H23.4165C27.0525 22.5 30 25.4475 30 29.0835V31.3055C30 32.5175 29.0175 33.5 27.8055 33.5H12.1945C10.9825 33.5 10 32.5175 10 31.3055V29.0835Z" fill="#FAABFF"/>
<defs>
<linearGradient id="paint0_linear_8738_113276" x1="15.5264" y1="18.7396" x2="24.2607" y2="9.39583" gradientUnits="userSpaceOnUse">
<stop stop-color="#5D34F2"/>
<stop offset="1" stop-color="#FF88FA"/>
</linearGradient>
</defs>
</svg>
